const title = 'MOA | CRENESSITY® (crinecerfont) HCP';
const description = 'Explore the mechanism of action (MOA) for CRENESSITY® and how it may help in the treatment of classic congenital adrenal hyperplasia (CAH). See full Prescribing and Safety Information.';
export const meta = {
  title,
  footer: {
    code: <>CP-CFT-US-0263v5</>,
    codeDate: <>08/2026</>,
    codeYear: <>2026</>,
  },
  metadata: [
    {
      name: 'description',
      content: description,
    }, {
      name: 'twitter:title',
      content: title,
    }, {
      name: 'twitter:description',
      content: description,
    }, {
      property: 'og:title',
      content: title,
    }, {
      property: 'og:description',
      content: description,
    }, {
      property: 'og:url',
      content: 'https://www.crenessityhcp.com/mechanism-of-action',
    }, {
      property: 'og:site_name',
      content: 'CRENESSITY® (crinecerfont) HCP Website'
    }, {
      property: 'og:type',
      content: 'website',
    }, {
      property: 'og:image',
      content: 'https://www.crenessityhcp.com/images/og/MOA_Hero-Image.png',
    }, 
  ],
  link: [
    {
      rel: 'canonical',
      href: 'https://www.crenessityhcp.com/mechanism-of-action',
    }, {
      rel: 'alternate',
      hrefLang: 'en-us',
      href: 'https://www.crenessityhcp.com/mechanism-of-action',
    },
  ],
  schemaTag: [
    {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "MedicalWebPage",
          "@id": "https://www.crenessityhcp.com/mechanism-of-action#webpage",
          "url": "https://www.crenessityhcp.com/mechanism-of-action",
          "name": "MOA | CRENESSITY® (crinecerfont) HCP",
          "description": "Explore the mechanism of action (MOA) for CRENESSITY® and how it may help in the treatment of classic congenital adrenal hyperplasia (CAH). See full Prescribing and Safety Information.",
          "isPartOf": {
            "@type": "WebSite",
            "name": "CRENESSITY HCP",
            "url": "https://www.crenessityhcp.com"
          },
          "dateModified": "2025-09-15T00:00:00Z",
          "audience": {
            "@type": "MedicalAudience",
            "audienceType": "HealthcareProvider"
          },
          "about": [
            {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/"
            },
            {
              "@type": "Drug",
              "name": "crinecerfont",
              "alternateName": [
                "CRENESSITY",
                "CRENESSITY crinecerfont"
              ],
              "sameAs": "https://go.drugbank.com/drugs/DB18518"
            }
          ],
          "publisher": {
            "@id": "https://www.neurocrine.com/#org"
          },
          "breadcrumb": {
            "@id": "https://www.crenessityhcp.com/mechanism-of-action#breadcrumbs"
          }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.crenessityhcp.com/mechanism-of-action#breadcrumbs",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.crenessityhcp.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Mechanism of Action",
              "item": "https://www.crenessityhcp.com/mechanism-of-action"
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.neurocrine.com/#org",
          "name": "Neurocrine Biosciences, Inc.",
          "url": "https://www.neurocrine.com/"
        }
      ]
    }
  ]
};